import React from "react"
import { Twitter, Instagram, LinkedIn } from "components/SVG"

import { container, socialIcons } from "./AuthorFollow.css"

type Props = {
  fullName: string
  twitter?: string
  instagram?: string
  linkedIn?: string
}

export const AuthorFollow: React.FC<Props> = ({
  fullName,
  twitter,
  instagram,
  linkedIn,
}) => (
  <div className={container}>
    <h5>Follow {fullName}</h5>
    <div className={socialIcons}>
      {twitter && (
        <a
          href={twitter}
          title={`Follow ${fullName} on Twitter`}
          target="_blank"
          rel="noreferrer"
        >
          <Twitter />
        </a>
      )}
      {instagram && (
        <a
          href={instagram}
          title={`Follow ${fullName} on Instagram`}
          target="_blank"
          rel="noreferrer"
        >
          <Instagram />
        </a>
      )}
      {linkedIn && (
        <a
          href={linkedIn}
          title={`Follow ${fullName} on LinkedIn`}
          target="_blank"
          rel="noreferrer"
        >
          <LinkedIn />
        </a>
      )}
    </div>
  </div>
)
